import type { SetStateAction } from 'react';
import { atom, type WritableAtom } from 'jotai';
import { atomFamily } from 'jotai-family';

import type { DisplayModeConfig, RecaptchaConfig } from '@repo/shared/types/dashboard';
import type { RfRecaptchaAssessmentAudit, RfRecaptchaLoadFailure } from '@repo/shared/types/core/recaptcha';

export const requestOriginHostAtom = atom<Required<Pick<Location, 'host' | 'hostname' | 'origin' | 'port' | 'protocol'>> & { originalRequestHref?: string; }>({} as Required<Pick<Location, 'host' | 'hostname' | 'origin' | 'port' | 'protocol'>> & { originalRequestHref?: string; });

export const displayModeConfigAtom = atom<DisplayModeConfig>({
	isEmbeddedWidgetMode: false,
	isWhitelabelDomainMode: false,
	isSharedMode: false,
	isPreviewMode: false,
	isCatalogFilterMode: false,
	isReadonlyMode: false,
	isChromeExtensionMode: false
});

export const hubRecaptchaConfigAtom = atom<RecaptchaConfig | undefined>(undefined);

export const recaptchaLoadFailureAtom = atom<RfRecaptchaLoadFailure | undefined>(undefined);

export const createDefaultRfRecaptchaAssessmentAudit = (): RfRecaptchaAssessmentAudit => ({
	assessmentToken: undefined,
	assessmentTokenExpiresAt: undefined,
	isChallengeRequired: false,
	challengeSolveCount: 0,
	assessments: []
});

export const recaptchaAssessmentAtomFamily = atomFamily<{ apiKey: string; }, WritableAtom<RfRecaptchaAssessmentAudit, [SetStateAction<RfRecaptchaAssessmentAudit>], void>>(({ apiKey: _apiKey }) => {
	return atom<RfRecaptchaAssessmentAudit>(createDefaultRfRecaptchaAssessmentAudit());
}, (auditA, auditB) => auditA.apiKey === auditB.apiKey);
